import React from 'react';

export default function HelpPanel({ title = 'Quick Guide', items = [] }){
  return (
    <div style={{ border: '1px solid var(--b0)', padding: 12, borderRadius: 6, background: 'var(--raised)', maxWidth: 420 }}>
      <div style={{ fontWeight: 800, fontFamily: 'Syne', fontSize: 13, marginBottom: 8 }}>{title}</div>
      <div style={{ fontSize: 12, color: 'var(--t3)', lineHeight: 1.45 }}>
        {items.map((it, i) => (
          <div key={i} style={{ marginBottom: 8 }}>
            <div style={{ fontWeight: 700, color: 'var(--t1)', fontSize: 12 }}>{it[0]}</div>
            <div style={{ fontSize: 12, color: 'var(--t3)' }}>{it[1]}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
